'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import AdminAuditLogsContent from './components/AdminAuditLogsContent';

export default function AdminAuditLogsPage() {
  return (
    <AppLayout activePath="/admin/audit-logs">
      <AdminAuditLogsContent />
    </AppLayout>
  );
}
